module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "form-check dawn-radio"
  }, [_c('label', {
    staticClass: "form-check-label"
  }, [_c('input', _vm._b({
    staticClass: "form-check-input",
    attrs: {
      "type": "radio",
      "name": _vm.name,
      "id": _vm.optionLabel
    },
    domProps: {
      "value": _vm.optionStatus,
      "checked": _vm.optionStatus
    },
    on: {
      "click": _vm.chooseRadio
    }
  }, 'input', _vm.$props, false)), _vm._v(_vm._s(_vm.optionLabel))])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3f07d636","hasScoped":false}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/core/components/edRadio/radio.vue
// module id = LsrB
// module chunks = 13 14